import "@/App.css";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import { Toaster } from "sonner";
import {
  ChartBar,
  PaperPlaneTilt,
  ClockCounterClockwise,
  Gear,
  ShieldCheck,
  Envelope,
} from "@phosphor-icons/react";
import Dashboard from "@/pages/Dashboard";
import Compose from "@/pages/Compose";
import History from "@/pages/History";
import Settings from "@/pages/Settings";
import Deliverability from "@/pages/Deliverability";

const NAV = [
  { to: "/", label: "Dashboard", icon: ChartBar, end: true },
  { to: "/compose", label: "Compose", icon: PaperPlaneTilt },
  { to: "/history", label: "History", icon: ClockCounterClockwise },
  { to: "/deliverability", label: "Deliverability", icon: ShieldCheck },
  { to: "/settings", label: "SMTP Settings", icon: Gear },
];

function Sidebar() {
  return (
    <aside
      data-testid="sidebar"
      className="w-64 shrink-0 border-r border-[#E5E7EB] bg-[#F9FAFB] flex flex-col min-h-screen sticky top-0"
    >
      <div className="h-20 flex items-center gap-3 px-6 border-b border-[#E5E7EB] bg-white">
        <div className="w-9 h-9 bg-[#09090B] flex items-center justify-center">
          <Envelope size={20} weight="fill" color="#ffffff" />
        </div>
        <div className="leading-none">
          <div className="font-display font-extrabold text-lg tracking-tight">
            Inbox<span className="text-[#2563EB]">Mailer</span>
          </div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#A1A1AA] mt-1">
            Delivery Engine
          </div>
        </div>
      </div>

      <nav className="flex-1 py-6">
        {NAV.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-6 py-3 text-sm font-medium border-l-2 transition-colors duration-150 ${
                isActive
                  ? "border-[#2563EB] bg-white text-[#09090B]"
                  : "border-transparent text-[#52525B] hover:bg-[#F3F4F6] hover:text-[#09090B]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={18} weight={isActive ? "fill" : "regular"} />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="p-6 border-t border-[#E5E7EB]">
        <div className="text-[10px] tracking-[0.15em] uppercase text-[#A1A1AA] leading-relaxed">
          Custom From-Name<br />Separate Reply-To
        </div>
      </div>
    </aside>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" theme="light" toastOptions={{ style: { borderRadius: 0 } }} />
      <BrowserRouter>
        <div className="flex">
          <Sidebar />
          <main className="flex-1 min-w-0">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/compose" element={<Compose />} />
              <Route path="/history" element={<History />} />
              <Route path="/deliverability" element={<Deliverability />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
